import React from 'react'
import { CompanyPageLayout } from 'client-portal/components/PageLayout'
import { RouteComponentProps } from 'react-router-dom'
import EventsComponent from './EventsComponent'

interface RouterProps {
  eventId: string
}

type EventProps = RouteComponentProps<RouterProps>

const EventDetail: React.VFC<EventProps> = ({ match }) => (
  <CompanyPageLayout>
    <EventsComponent eventId={match.params.eventId} isClient />
  </CompanyPageLayout>
)

export default EventDetail
